import React, { useEffect, useState } from "react";
import axios from "axios";
import progressGif from "../../images/progress.gif";
import Non_Avail_Card_Report from "./Non_Avail_Cards_Report";

const Non_Avail_Cards = () => {
  const [monthYearList, setMonthYearList] = useState([]);
  const [selectedMonthYear, setSelectedMonthYear] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showGif, setShowGif] = useState(false);
  const [showReport, setShowReport] = useState(false);

  useEffect(() => {
    const fetchMonthYear = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/nonAvailCards/monthYear`,
          { withCredentials: true }
        );

        const data = response.data || [];
        if (!Array.isArray(data) || !data.length) {
          setMessage("No data found for this user session.");
          return;
        }

        const { monthActive, noOfMonth } = data[0];
        const monthNames = [
          "January","February","March","April","May","June",
          "July","August","September","October","November","December"
        ];

        const now = new Date();
        const currentMonth = now.getMonth();
        const currentYear = now.getFullYear();
        const includeCurrent = monthActive === 1;
        const monthsToShow = noOfMonth || 3;
        const list = [];

        for (let i = 0; i < monthsToShow; i++) {
          const offset = includeCurrent ? i : i + 1;
          const date = new Date(currentYear, currentMonth - offset, 1);
          const month = monthNames[date.getMonth()];
          const year = date.getFullYear();
          list.push(`${month} ${year}`);
        }

        setMonthYearList(list);
        setSelectedMonthYear(list[0]);
      } catch (err) {
        console.error(err);
        setMessage("Failed to load month-year data.");
      } finally {
        setLoading(false);
      }
    };

    fetchMonthYear();
  }, []);

  const handleGenerate = async () => {
    if (!selectedMonthYear) {
      alert("Please select a month and year first!");
      return;
    }

    const [monthName, yearStr] = selectedMonthYear.split(" ");
    const month = new Date(`${monthName} 1, 2000`).getMonth() + 1;
    const year = parseInt(yearStr, 10);

    setMessage("");
    setShowGif(true);
    setLoading(true);
    setShowReport(false);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/nonAvailCards/generate`,
        { params: { month, year }, withCredentials: true }
      );

      const data = response.data;

      setTimeout(() => {
        setShowGif(false);
        setLoading(false);

        if (data.status === -1) {
          setMessage(data.message || "Function already running. Please wait...");
          setShowReport(false);
        } else if (data.message && !data.message.includes("Data generated successfully")) {
          setMessage(data.message);
          setShowReport(false);
        } else {
          setMessage(data.message);
          setShowReport(true);
        }
      }, 10);
    } catch (err) {
      console.error(err);
      setTimeout(() => {
        setShowGif(false);
        setLoading(false);
        setMessage("Failed to generate data.");
        setShowReport(false);
      }, 1000);
    }
  };

  return (
    <div style={{ padding: "30px", fontFamily: "Arial, sans-serif",
     display: "flex", flexDirection: "column", alignItems: "center" }}>
      <table style={{ width: "25%",   
  borderCollapse: "collapse", 
  boxShadow: "0 0 8px rgba(0,0,0,0.1)", 
  tableLayout: "fixed"  }}>
        <thead>
          <tr style={{ backgroundColor: "black", color: "white" }}>
            <th colSpan="2" style={{ textAlign: "center", padding: "8px", 
              fontSize: "16px", fontWeight: "bold" }}>Non Avail Cards</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ padding: "8px", fontWeight: "bold", width: "20%", 
              fontSize: "12px" }}>Allotment Month & Year</td>
            <td style={{ padding: "8px 10px", textAlign: "left" }}>
              <select value={selectedMonthYear} onChange={(e) => setSelectedMonthYear(e.target.value)} 
              style={{ padding: "4px", fontSize: "13px", borderRadius: "4px", border: "1px solid #ccc", 
              width: "70%", textAlign: "left" }}>
                {monthYearList.map((item, index) => (
                  <option key={index} value={item}>{item}</option>
                ))}
              </select>
            </td>
          </tr>
          <tr>
            <td colSpan="2" style={{ textAlign: "center", padding: "4px" }}>
              <button onClick={handleGenerate} disabled={loading} style={{ backgroundColor: "#101213",
                 color: "white", border: "none", borderRadius: "18px", padding: "6px 20px", fontSize: "12px" }}>
                Generate Non Avail Cards
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      {showGif && 
      <div style={{ textAlign: "center", marginTop: "15px" }}>
        <img src={progressGif} alt="Loading..." width="220" height="12" /></div>}

      {message && !showGif && <div 
      style={{ marginTop: "20px",
        width: "45%",
        textAlign: "center", 
      fontWeight: "bold", 
      color: "darkred", 
      textDecoration: "underline", 
      fontSize: "16px" }}>
        {message}
        </div>}

      {showReport && <div 
      style={{ marginTop: "10px" }}>
        <Non_Avail_Card_Report />
        </div>}
    </div>
  );
};

export default Non_Avail_Cards;
